import React, { Fragment, useState } from "react";
import { Form, Input, message, Modal, Select } from "antd";
import { HomeRepository, HomeSectionType } from "../../../../../domain";
import { logger } from "../../../../../utils";
import I18n from "../../../../i18n";
import { ServiceLocater, Services } from "../../../../../service-locater";
import { useAppDispatch } from "../../../../../application/store";
import { loadHome } from "../../../../../application/home-slice";

const { useForm, Item } = Form;

type NewHomeSectionModalProps = {
  visible: boolean;
  onClose: () => void;
};

const NewHomeSectionModal: React.FC<NewHomeSectionModalProps> = ({
  visible,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const [form] = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState<HomeSectionType>("2Image");
  const [image1, setImage1] = useState<File>();
  const [image2, setImage2] = useState<File>();
  const [image3, setImage3] = useState<File>();
  const [image4, setImage4] = useState<File>();

  const closeAndDestroy = () => {
    form.resetFields();
    onClose();
  };

  const submit = async () => {
    try {
      if (type !== "Scroll") await form.validateFields();
      if (type === "2Image")
        if (image1 === undefined || image2 === undefined) return;
      if (type === "4Image")
        if (image3 === undefined || image4 === undefined) return;
      setIsLoading(true);
      let products = [];
      if (type === "Scroll")
        for (let index = 0; index <= 10; index++) {
          const element = form.getFieldValue(`productId${index}`);
          if (element !== undefined) products.push(element);
        }
      const res = await ServiceLocater.get<HomeRepository>(
        Services.HomeRepository
      ).addHomeSection(
        type,
        [
          ...((type === "2Image" || type === "4Image") &&
          image1 !== undefined &&
          image2 !== undefined
            ? [
                {
                  image: image1,
                  link: form.getFieldValue("link1"),
                },
                {
                  image: image1,
                  link: form.getFieldValue("link2"),
                },
              ]
            : []),
          ...(type === "4Image" && image3 !== undefined && image4 !== undefined
            ? [
                {
                  image: image3,
                  link: form.getFieldValue("link3"),
                },
                {
                  image: image4,
                  link: form.getFieldValue("link4"),
                },
              ]
            : []),
        ],
        products,
        form.getFieldValue("title"),
        form.getFieldValue("description")
      );
      setIsLoading(false);
      res.fold(
        (_) => {
          message.error(I18n.general.networkError);
        },
        (_) => {
          closeAndDestroy();
          message.success("ردیف با موفقیت افزوده شد");
          dispatch(loadHome());
        }
      );
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <Modal
      visible={visible}
      onOk={submit}
      bodyStyle={{ paddingBottom: 0 }}
      title={"ردیف جدید"}
      closable={!isLoading}
      maskClosable={!isLoading}
      onCancel={isLoading ? undefined : onClose}
      confirmLoading={isLoading}
    >
      <Form form={form}>
        <Item name="type" required label={"نوع"}>
          <Select
            defaultValue="2Image"
            value={type}
            onChange={(value) => setType(value)}
          >
            <Select.Option value="2Image">دو عکس</Select.Option>
            <Select.Option value="4Image">چهار عکس</Select.Option>
            <Select.Option value="Scroll">نوار محصولات</Select.Option>
          </Select>
        </Item>

        {type === "Scroll" ? (
          <Fragment>
            <Item name="title" label={"عنوان"}>
              <Input name="title" maxLength={100} />
            </Item>
            <Item name="description" label={"توضیحات"}>
              <Input.TextArea name="description" />
            </Item>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((index) => {
              return (
                <Item
                  label={`محصول ${index}`}
                  name={`productId${index}`}
                  rules={[{ validateTrigger: "onSubmit", type: "integer" }]}
                >
                  <Input
                    name={`productId${index}`}
                    onChange={(value) => {
                      form.setFields([
                        {
                          name: `productId${index}`,
                          value: value.target.value,
                        },
                      ]);
                    }}
                  />
                </Item>
              );
            })}
          </Fragment>
        ) : (
          <Fragment>
            <Item name="title" label={"عنوان"}>
              <Input name="title" maxLength={100} />
            </Item>
            <Item name="description" label={"توضیحات"}>
              <Input.TextArea name="description" />
            </Item>
            {[1, 2, ...(type === "4Image" ? [3, 4] : [])].map((index) => {
              return (
                <div>
                  <Item
                    name={`image${index}`}
                    label={`عکس ${index}`}
                    required
                    rules={[{ required: true, validateTrigger: "onSubmit" }]}
                  >
                    <Input
                      name={`image${index}`}
                      type="file"
                      onChange={(e) => {
                        if (e.target.files !== null) {
                          const image = e.target.files[0];
                          if (index === 1) setImage1(image);
                          else if (index === 2) setImage2(image);
                          else if (index === 3) setImage3(image);
                          else setImage4(image);
                        }
                      }}
                    />
                  </Item>
                  <Item
                    name={`link${index}`}
                    label={`لینک ${index}`}
                    required
                    rules={[
                      {
                        required: true,
                        validateTrigger: "onSubmit",
                        type: "string",
                      },
                    ]}
                  >
                    <Input name={`link${index}`} maxLength={200} />
                  </Item>
                </div>
              );
            })}
          </Fragment>
        )}
      </Form>
    </Modal>
  );
};

export default NewHomeSectionModal;
